import React, { useEffect, useRef } from 'react';
export function MatrixRain() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    // Matrix characters: katakana + numbers + symbols
    const chars = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ@#$%^&*()+=<>?/{}[]|~';
    const charArray = chars.split('');
    const fontSize = 14;
    let columns = 0;
    let drops: number[] = [];
    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      columns = Math.floor(canvas.width / fontSize);
      drops = Array.from({
        length: columns
      }, () => Math.random() * -100);
    };
    resize();
    window.addEventListener('resize', resize);
    const draw = () => {
      // Semi-transparent black to create fade trail
      ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.font = `${fontSize}px monospace`;
      for (let i = 0; i < drops.length; i++) {
        const char = charArray[Math.floor(Math.random() * charArray.length)];
        const x = i * fontSize;
        const y = drops[i] * fontSize;
        // Bright head character
        if (Math.random() > 0.5) {
          ctx.fillStyle = 'rgba(0, 212, 170, 0.9)'; // bright teal head
        } else {
          ctx.fillStyle = 'rgba(0, 212, 170, 0.4)'; // dimmer teal body
        }
        // Occasionally a bright white flash for the leading character
        if (Math.random() > 0.96) {
          ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
        }
        ctx.fillText(char, x, y);
        // Reset drop to top with randomness
        if (y > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }
        drops[i] += 0.5 + Math.random() * 0.5;
      }
    };
    const interval = setInterval(draw, 50);
    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resize);
    };
  }, []);
  return <canvas ref={canvasRef} className="absolute inset-0 w-full h-full opacity-30 pointer-events-none" style={{
    zIndex: 1
  }} data-id="element-356" />;
}